import {
	RadioGroup,
	Radio,
	FormControl,
	FormControlLabel,
} from '@mui/material';
import styles from './multiFactor.module.css';

const MethodSwitch = (props) => {
	return (
		<FormControl className={styles.switcherRadiosRoot}>
			<div
				id='demo-radio-buttons-group-label'
				className={styles.switcherRadiosLabel}>
				Where should we send the code?
			</div>
			<RadioGroup
				className={styles.switcherRadiosGroup}
				aria-labelledby='demo-radio-buttons-group-label'
				value={props.value}
				onChange={props.onChange}
				name='radio-buttons-group'>
				<FormControlLabel value='phone' control={<Radio />} label='Phone' />
				<FormControlLabel value='email' control={<Radio />} label='Email' />
			</RadioGroup>
		</FormControl>
	);
};

export default MethodSwitch;
